import React, { Component } from 'react'
import './SessionBar.css';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Popup from '../Popup/Popup';
import ButtonBar from '../ButtonBar/ButtonBar';

class SessionBar extends Component {
  state = {
    isOpen: false
  }

  handleClick = () => {
    alert("Call 4057/4059 for Assistance");
  }

  render() {
    return (
      <div>
        <div className='Session-header'> 
        <div>
            <p className='Session-Name'>Session Name : </p>
            <p className='Session-Value'>{this.props.name}</p>
        </div>
        <HelpOutlineIcon onClick={this.handleClick} className='Icon' sx={{color: '#810055' , fontSize: '18px'}} />
        <Popup isOpen={this.state.isOpen} onClose={()=>this.setState({isOpen: false})}>Call 4057/4059 for Assistance</Popup>
      </div>
      <ButtonBar/>
      </div>
      
    )
  }
}

export default SessionBar;